<template>
    <div>
        <v-card>
            <v-card-actions class="mx-3">
                <v-spacer></v-spacer>
                <v-btn class="mr-3 mb-3 white--text" small color="green" depressed @click="export2xls">Export to XLS</v-btn>
            </v-card-actions>
            <v-card-subtitle>
                <div style="text-align:center; font-weight:bold; font-size:16px; padding:10px">Jadwal Kirim LK</div>

                <v-row class="compact-form my-2">
                    <v-col cols="1">
                        Tanggal
                    </v-col>
                    <v-col cols="3" class="">
                        <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="reportDate" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="reportDate" :allowed-dates="allowedDates"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="2">
                        <v-btn depressed color="primary" @click="runReport">Run</v-btn>
                    </v-col>
                </v-row>                

            </v-card-subtitle>

            <v-simple-table ref="tableBOM" id="variantTbl" class="pa-5">
            <tbody>
                <template v-for="(outlet, oIdx) in printObj">
                <!-- Judul Outlet -->
                <tr :key="`title-${oIdx}`">
                    <td colspan="7" style="font-weight:bold; text-align:left; background:#eee;">
                    {{ outlet.outlet_name }}
                    </td>
                </tr>

                <!-- Header ulang -->
                <tr :key="`header-${oIdx}`">
                    <th>Sales</th>
                    <th>Expired</th>
                    <th>Pickup</th>
                    <th>Tiba</th>
                    <th>Lumerin</th>
                    <th>Total Botol Kirim</th>
                </tr>

                <!-- Data -->
                <tr v-for="(row, rIdx) in outlet.data" :key="`${oIdx}-${rIdx}`">
                    <td>{{ row.sales_date | moment }}</td>
                    <td><span v-show="row.total_botol">{{ row.expired_date | moment2 }}</span></td>
                    <td><span v-show="row.total_botol">{{ row.actual_delivery_date | moment }}</span></td>
                    <td><span v-show="row.total_botol">{{ row.arrival_date | moment }}</span></td>
                    <td><span v-show="row.total_botol">{{ row.lumerin_date | moment }}</span></td>
                    <td><span v-show="row.total_botol">{{ row.total_botol }}</span></td>
                </tr>

                <!-- Catatan -->
                <tr :key="`note-${oIdx}`">
                    <td colspan="7" style="color:red;">
                    Semua jus dari outlet {{ outlet.outlet_name }} wajib simpan di freezer sampai hari lumer. 
                    <br>Dilarang simpan di undercounter chiller
                    </td>
                </tr>
                </template>
            </tbody>
            </v-simple-table>

        </v-card>
        <v-overlay :value="onLoad" z-index="999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>        

    </div>
</template>

<script>
import moment from 'moment'
import { utils, writeFileXLSX } from 'xlsx';

export default {

    data: () => ({
      dialog: false,
      onLoad: false,
      printObj: [],
      dateMenu: false,
      reportDate: null,
      allowedDates: val => new Date(val+' 00:00:00').getDay() === 0
    }),

    computed: {
      miscCodes() {
        return this.$store.state.misccode.objs
      },
    },

    watch: {
    },

    filters: {
        moment: function (date) {
            return moment(date).format('ddd, D-MMM');
        },
        moment2: function (date) {
            return moment(date).format('D-MMM');
        },
        numbers: function (number) {
            return Number(number).toLocaleString()
        },
    },

    async created() {
    },

    methods: {
        addDate(nday){
            const dt = new Date(this.reportDate + ' 00:00:00')
            dt.setDate(dt.getDate()+ nday)
            return dt
        },
        convertData(data) {
            const grouped = data.reduce((acc, item) => {
                if (!acc[item.outlet_code]) {
                acc[item.outlet_code] = {
                    outlet_code: item.outlet_code,
                    outlet_name: item.outlet_name,
                    data: []
                };
                }
                // const { outlet_code, ...rest } = item; // remove outlet_code inside child
                acc[item.outlet_code].data.push(item);
                return acc;
            }, {});

            return Object.values(grouped); // convert object to array
        },
        async runReport() {
            this.onLoad = true
            const data = (await this.$store.dispatch('getObjs',{apidomain:'others/rptjadwalkirimlk/', parameter:this.reportDate})).data
            this.printObj = this.convertData(data)
            console.log(this.printObj)
            this.onLoad = false
        },
        onProgress(progress) {
            this.progress = progress;
            console.log(`PDF generation progress: ${progress}%`)
        },
        export2xls() {
            console.log(this.$refs.tableBOM.$el.firstChild.firstChild)
            const wb = utils.table_to_book(this.$refs.tableBOM.$el.firstChild.firstChild)
            writeFileXLSX(wb, "FRM-005.xlsx")

        },



    },

}    

</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}
#printresep th, td {
  padding: 10px;
  font-size: 12px;
}
.box {
    border:1px solid grey;
    height:30px;
    width:100px;    
}
</style>